import _ from "lodash";
import { useDispatch } from "react-redux";
import { resetFilesData } from "@Actions/fileUpload";
import { resetViewerState, setModalStatus, setModelProperties } from "@Reducers/Viewer";
import { setFileversionIdAndNodeOffsetIdMap } from "@Reducers/common";

const useResetDesignViewer = () => {
  const dispatch = useDispatch<any>();

  return () => {
    dispatch(resetViewerState());
    dispatch(resetFilesData());
    dispatch(setFileversionIdAndNodeOffsetIdMap({}));
    dispatch(setModalStatus({}));
    dispatch(
      setModelProperties({
        isLoading: false,
        isLoaded: false,
        isFileFormTemplatesLoaded: false,
        isFileFormTemplatesLoading: false,
        formTemplates: {},
        defaultTemplate: {},
      }),
    );
  };
};

export default useResetDesignViewer;
